<div class="marine-insurance-terms">
  <p>
    {{ "MARINE_INSURANCE_TERMS_HEADER" | translate }}
    <a [routerLink]="['/legal-terms']">
      {{ "LABELS.LEGAL_TERMS_DISCLAIMER_LINK" | translate }}
    </a>
  </p>
  <ul>
    <li>
      {{ "MARINE_INSURANCE_TERMS_LINE_1" | translate }}
    </li>

    <li>{{ "MARINE_INSURANCE_TERMS_LINE_2" | translate }}</li>

    <li>{{ "MARINE_INSURANCE_TERMS_LINE_3" | translate }}</li>

    <li>
      {{ "MARINE_INSURANCE_TERMS_LINE_4" | translate }}
      <a href="https://eezyimportcommonfiles.blob.core.windows.net/eezyimportpublic/Anova%20Cargo%20Policy.pdf" target="_blank">
        {{ "PROHIBITED_COUNTRIES" | translate }}
      </a>
      .
    </li>

    <li>
      {{ "MARINE_INSURANCE_TERMS_LINE_5" | translate }}
      <a href="https://eezyimportcommonfiles.blob.core.windows.net/eezyimportpublic/Anova%20Cargo%20Policy.pdf" target="_blank">
        {{ "GOODS_RESTRICTIONS" | translate }}
      </a>
      .
    </li>

    <li>
      {{ "MARINE_INSURANCE_TERMS_LINE_6" | translate }}
      <a href="mailto:claims@anovamarine.com" target="_blank">claims@anovamarine.com</a>
      .
    </li>

    <li>
      {{ "MARINE_INSURANCE_PAYMENT_NOTE_1" | translate }}
      <a href="mailto:help@eezyimport.com" target="_blank">help@eezyimport.com</a>
      .
    </li>
  </ul>
</div>
